<template>

  <b-card
    no-body
    class="mb-1 bg-light-primary rounded"
  >
    <b-card-header
      header-tag="header"
      class="p-1"
      role="tab"
    >
      <b-button
        v-b-toggle.accordion-1
        block
        variant="primary"
      >
        INSTRUCCIONES CALIFICACIONES
      </b-button>
    </b-card-header>

    <b-collapse
      id="accordion-1"
      visible
      accordion="my-accordion"
    >

      <b-card-text class="p-2">
        <ol>
          <p class="m-0">
            <strong>¡Importante! Se debe de realizar el Pre Cierre, Autorización y Cierre de Ciclo para cada Plan.</strong>
          </p>

          <li><strong>
                Antes de empezar hay que asegurarse de que existen los eventos en el calendario para evaluar.
              </strong>
            <p class="m-0">
              - Pre cierre (Servicios Escolares)
            </p>
            <p class="m-0">
              - Captura de calificaciones (Servicios Escolares y Asesor)
            </p>
            <p class="m-0">
              - Solicitud de ajuste (Asesor, Alumno, CHyJ)
            </p>
            <p class="m-0">
              - Resolución de ajuste (CHyJ)
            </p>
            <p class="m-0">
              - Cierre de cuatrimestre (Servicios Escolares)
            </p>
          </li>

          <li>Paso 1 - <b>pre cierre</b>  (seleccione plan y periodo) - extrae las calificaciones de la plataforma Moodle y se guardan en Campus Virtual.
          </li>
          <li>Paso 2 - <b>Cada profesor debe de validar las calificaciones (extraídas de Moodle) de cada curso asignado a ellos</b>
            (asegúrese que en la edición del curso, en la sección de recurso esté el nombre del profesor con rol de titular);
            <strong>para continuar con el proceso, deben de validarse todos los cursos de todos los niveles del plan de estudios.</strong>
            (seleccione plan, periodo y curso), <strong>En este paso el profesor puede cambiar la calificación justificando la nueva calificación</strong> (examen de acreditación).</li>
          <li>Paso 3 - <b> Autorizar </b> las calificaciones que asignaron los profesores  (seleccione plan y periodo).</li>
          <li>Paso intermedio (opcional) - <b>Tanto los alumnos como los profesores pueden solicitar un cambio de calificación, esta solicitud la resolverá el Comité de Honor y Justicia.</b></li>
          <li>Paso 4 - <b>Cierre de Ciclo</b> Una vez autorizadas las calificaciones y se hayan resuelto todas las solicitudes del CHyJ se puede cerrar el ciclo. Al cerrar el ciclo la calificación será guardada en el kardex de manera definitiva sin oportunidad de cambios. (seleccione plan y periodo).</li>
        </ol>
      </b-card-text>

    </b-collapse>
  </b-card>

</template>

<script>
import {
  BCard, BCardHeader,
  BButton, BCardText,
  BCollapse, VBToggle,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'

import store from '@/store'

export default {
  components: {
    BCollapse,
    BCard,
    BCardText,
    BButton,
    BCardHeader,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  setup() {
    const userRole = computed(() => store.state.cuenta.rolSelected)

    return {
      userRole,
    }
  },
}
</script>
